var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeriaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.375H27V20.625H0V0.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9972 0.375H27V20.625H17.9972V0.375ZM0 0.375H8.99859V20.625H0V0.375Z",
    fill: "#008753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaFlag);
export default __webpack_public_path__ + "static/media/nigeria-flag.1d096a54228ececa714d07d2b4fd8bfe.svg";
export { ForwardRef as ReactComponent };